// LandingPage.jsx
// React equivalent of escape_peace-old/index.php — landing / Begin Play screen.
import React from 'react';
import { Link } from 'react-router-dom';
import EscapeHeader from '../../../components/escape-to-inner-peace/layout/EscapeHeader';
import { useEscapeReplayStatus } from '../../../games/escape-to-inner-peace/hooks/useEscapeReplayStatus';
import '../../../games/escape-to-inner-peace/styles/theme.css';
import logo from '../../../assets/escape-to-inner-peace/images/logo.png';
import './landing.css';

function LandingAction() {
  const replay = useEscapeReplayStatus();

  if (replay.status === 'loading') {
    return (
      <p className="escape-landing-status" data-testid="escape-landing-status-loading">
        Checking your play status…
      </p>
    );
  }

  if (replay.status === 'blocked') {
    return (
      <div className="escape-landing-status escape-landing-status--blocked" data-testid="escape-landing-replay-blocked">
        <p>You have played this game already</p>
        <Link to="/escape-to-inner-peace/result" className="escape-begin-btn" data-testid="escape-landing-view-result">
          View Your Result
        </Link>
      </div>
    );
  }

  if (replay.status === 'error') {
    return (
      <div className="escape-landing-status escape-landing-status--error" data-testid="escape-landing-replay-error">
        <p>{replay.error || 'Could not check your play status.'}</p>
        <button
          type="button"
          className="escape-begin-btn"
          onClick={replay.retry}
          data-testid="escape-landing-replay-retry"
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <Link to="/escape-to-inner-peace/intro" className="escape-begin-btn" data-testid="escape-landing-begin">
      BEGIN PLAY
    </Link>
  );
}

function LandingPage() {
  return (
    <div className="escape-landing-page">
      <EscapeHeader backHref="https://extramileplay.com" />

      <div className="escape-landing-center">
        <div className="escape-landing-logo-header">
          <div className="escape-landing-logo-wrap">
            <a href="https://extramileplay.com/" aria-label="Visit ExtraMile Play">
              <img src={logo} alt="Escape To Inner Peace" className="escape-landing-logo" />
            </a>
          </div>
        </div>

        <div className="escape-landing-action">
          <LandingAction />
        </div>
      </div>
    </div>
  );
}

export default LandingPage;